import { render, staticRenderFns } from "./PackagingSummary.vue?vue&type=template&id=5314953d&scoped=true&"
import script from "./PackagingSummary.vue?vue&type=script&lang=ts&"
export * from "./PackagingSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5314953d",
  null
  
)

export default component.exports